/**
 * Get the Rails CSRF data in the document header
 * @returns {{"X-CSRF-Param", "X-CSRF-Token"}}
 */
export const authenticityHeaders = () => ({
  "X-CSRF-Param": document.head.querySelector("[name=csrf-param]").content,
  "X-CSRF-Token": document.head.querySelector("[name=csrf-token]").content
});

export default authenticityHeaders;